import axios from "axios";

import { PRODUCTS } from "../../configs/api-config";

// Api calls
function get_products_api() {
  return axios.get(PRODUCTS);
}

export { get_products_api };

// old
export default {
  get_products: get_products_api,
};
